export const UPGRADE_DASHBOARD = 'Upgrade-Dashboard';
export const TOPBAR_VIEW_PLANS = "Topbar-View-Plans";
export const UPGRADE_EDITOR = "Upgrade-Editor";
export const ACCOUNT_CREATED = "Account-Created";
export const VISITED_UPGRADE_PLAN = "VISITED_UPGRADE_PLAN";
export const SELECT_PLAN = "Select-Plan";
export const PAID_FOR_PLAN = "Paid-For-Plan";
